import type { Issue } from "./types";

type TaskOwnership = Pick<
  Issue,
  "ownerId" | "executorAgentId" | "assigneeId"
>;

/**
 * Resolve the accountable human without mistaking the compatibility assignee
 * for a person. Since 00079, assigneeId points to the executor when an agent is
 * delegated, and only falls back to the owner when no executor exists.
 */
export function humanOwnerId(task: TaskOwnership): string | null {
  return task.ownerId ?? (task.executorAgentId == null ? task.assigneeId : null);
}
